import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation } from "@tanstack/react-query";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { createUOM } from "services/data.internal.service";
import UOMInfo from "./components/UOMInfo";
import { formRender, initialValues, uomValidations } from "./uom-schema";

function AddUOM() {
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const createUOMMutation = useMutation(createUOM, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(uomValidations),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    createUOMMutation.mutate(data, {
      onSuccess: () => {
        reset();
      },
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <UOMInfo {...infoProps} />
        <SubmitButton label="submit" disabled={isSubmitting} url="/setup/uom" />
      </form>
    </Layout>
  );
}

export default AddUOM;
